
    export default {
        name: 'PageSections',
        props: {
            pageContents: {
                type: Array,
                default: () => [],
            },
        },
    };
